// lib/inventory/brands/revenueCoverage.ts
import type { BrandRevenueCoverage, TableStatsResponseV1 } from '#types/types';

export function readBrandRevenueCoverage(data: TableStatsResponseV1 | null | undefined): BrandRevenueCoverage | null {
  const rows = Array.isArray(data?.sections) ? data.sections.find((section) => section?.id === 'revenue_coverage')?.rows : undefined;
  if (!Array.isArray(rows)) return null;
  const value = (key: string) => rows.find((row) => row?.key === key)?.value;
  const [brands, sourced, official, verified] = ['brands', 'sourced', 'official', 'verified'].map(value);
  if (![brands, sourced, official, verified].every((v) => typeof v === 'number' && Number.isSafeInteger(v) && v >= 0)) return null;
  const counts = { brands, sourced, official, verified } as BrandRevenueCoverage;
  if (counts.sourced > counts.brands || counts.official > counts.sourced || counts.verified > counts.brands) return null;
  return counts;
}
